import React from 'react'
import PropTypes from 'prop-types'
import ReactTable from 'react-table'
import styled from 'styled-components'
import styles from '../../../styles/App.css'
import { fullTextFilter } from '../../../utils/utils'
import {
  CellContainer,
  renderFilterInput,
  renderHeaderCell,
} from '../../UsersPage/index.screen'

const StyledTable = styled(ReactTable)`
  max-height: 385px;
`

/* eslint-disable react/prop-types, no-underscore-dangle */
const renderContent = (stores, onStore) => {
  const columns = [
    {
      sortable: true,
      width: 200,
      filterable: true,
      Header: renderHeaderCell('Store'),
      accessor: 'name',
      Cell: ({ original: { name } }) => (
        <CellContainer>
          <span className={styles.link}>{name}</span>
        </CellContainer>
      ),
      Filter: ({ filter, onChange }) =>
        renderFilterInput({ placeholder: 'Filter', filter, onChange }),
    },
  ]

  return (
    <StyledTable
      data={stores}
      columns={columns}
      defaultFilterMethod={fullTextFilter}
      getTdProps={(state, rowInfo, column) => ({
        onClick: (e, handleOriginal) => {
          if (column.id === 'name') {
            onStore(rowInfo.original)
          }

          if (handleOriginal) {
            handleOriginal()
          }
        },
      })}
      defaultPageSize={10}
    />
  )
}

function StoresScreen({ stores, onStore, id }) {
  return renderContent(stores, onStore, id)
}

StoresScreen.propTypes = {
  stores: PropTypes.array.isRequired,
  onStore: PropTypes.func.isRequired,
}

export default StoresScreen
